const CODEX_BROWSER_AUTH_STATE_KEY = 'fitro_codex_browser_auth_state'

export function isCodexBrowserModeEnabled(): boolean {
    if (process.env.NEXT_PUBLIC_FITRO_CODEX_BROWSER_MODE !== '1') return false
    if (typeof window === 'undefined') return true
    return isCodexBrowserHost(window.location.hostname)
}

export function isCodexBrowserHost(host: string | null | undefined): boolean {
    const normalized = normalizeHost(host)
    return normalized === 'localhost' || normalized.endsWith('.localhost') || normalized === '127.0.0.1' || normalized === '::1'
}

function normalizeHost(host: string | null | undefined): string {
    const first = host?.split(',')[0]?.trim().toLowerCase() ?? ''
    if (!first) return ''
    if (first.startsWith('[')) {
        return first.slice(1, first.indexOf(']'))
    }
    return first.split(':')[0] ?? ''
}

export function getCodexBrowserToken(): string | null {
    if (!isCodexBrowserModeEnabled()) return null
    if (!isCodexBrowserSignedIn()) return null
    const token = process.env.NEXT_PUBLIC_FITRO_CODEX_BROWSER_TOKEN?.trim()
    return token ? token : null
}

export function getCodexBrowserUserId(): string {
    return process.env.NEXT_PUBLIC_FITRO_CODEX_BROWSER_USER_ID?.trim() || 'user_codex_customer'
}

export function isCodexBrowserSignedIn(): boolean {
    if (process.env.NEXT_PUBLIC_FITRO_CODEX_BROWSER_AUTH_STATE === 'anonymous') return false
    if (typeof window === 'undefined') return true

    try {
        return window.sessionStorage.getItem(CODEX_BROWSER_AUTH_STATE_KEY) !== 'anonymous'
    } catch {
        return true
    }
}

export function signOutCodexBrowser(redirectUrl = '/'): void {
    if (typeof window === 'undefined') return

    try {
        window.sessionStorage.setItem(CODEX_BROWSER_AUTH_STATE_KEY, 'anonymous')
    } finally {
        window.location.assign(redirectUrl)
    }
}
